<template>
  <div>
    <BaseModal
      name="addMilage"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="closeModalAndClearData"
      @before-open="onOpen"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('addMilage')"
        ></button>

        <div
          v-if="stateLoading"
          class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white tw-rounded-[25px]"
          style="top: 0; left: 0; z-index: 500"
        >
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">
            <span v-if="dataForEmit.vehicle_services__service_type_id == 7">
              Обновить пробег
            </span>
            <span v-if="dataForEmit.vehicle_services__service_type_id == 8">
              Обновить моточасы
            </span>
          </div>

          <div ref="valueForSend">
            <BaseInputNew
              input-name="valueForSend"
              @input="updateValue"
              :horizontalTitle="true"
              :value="valueForSend"
              inputClass="tw-app-input-type-3"
            >
            </BaseInputNew>
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('addMilage')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="sendData(false)"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
              :disabled="submitting"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptUpdateMilage"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="closeModalAndClearData"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('acceptUpdateMilage')"
        ></button>

        <div
          v-if="stateLoading"
          class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white tw-rounded-[25px]"
          style="top: 0; left: 0; z-index: 500"
        >
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>

        <div class="tw-text-center">
          <div
            v-html="errorMessage"
            class="tw-text-[14px] tw-text-danger tw-my-[30px]"
          ></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptUpdateMilage')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="sendData(true)"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
              :disabled="submitting"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapState, mapMutations } from "vuex";
import ObjectService from "@/api/ObjectsService.js";
import EventBus from "@/event-bus.js";
// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {
    nameForAction: {
      type: String,
    },
    modalName: {},
    centered: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    size: {
      type: String,
      default: "",
    },
    minHeight: {
      type: Number,
    },
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      submitting: false,
      thisModal: null,
      errorMessage: "",
      valueForSend: null,
      dataForEmit: {
        vehicle_services__service_type_id: null,

        // "vehicle_services__service_type_id":8,
      },
    };
  },
  methods: {
    onOpen({ params }) {
      this.dataForEmit.vehicle_services__service_type_id = params.type;
    },
    updateValue(data) {
      this.valueForSend = data.value;
      this.$refs[data.name].classList.remove("input-error");
    },

    closeModalAndClearData() {
      this.valueForSend = null;
      if (
        this.$refs &&
        this.$refs["valueForSend"] &&
        this.$refs["valueForSend"].classList
      ) {
        this.$refs["valueForSend"].classList.remove("input-error");
      }
    },

    sendData(isConfirm) {
      this.submitting = true;
      ObjectService.createService(this.optionalParams.id, {
        ...this.dataForEmit,
        ...(this.dataForEmit.vehicle_services__service_type_id == 7
          ? {
              vehicle_services__odometr: this.valueForSend,
            }
          : { vehicle_services__motohour: this.valueForSend }),
        ...(isConfirm && { confirmed: true }),
      })
        .then((data) => {
          this.submitting = false;
          this.$toast.success("Запись добавлена");
          Object.keys(this.dataForEmit).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
          this.valueForSend = null;
          this.$modal.hide("addMilage");
          this.$modal.hide("acceptUpdateMilage");
        })
        .catch((err) => {
          this.submitting = false;
          const resp =
            err && err.response && err.response.data ? err.response.data : null;
          const status = err && err.response && err.response.status;
          if (status == 400 && resp) {
            // errorCode 1/11 means server requires explicit user confirmation
            if ([1, 11].includes(Number(resp.errorCode))) {
              // preserve entered value while switching modals
              const pendingValue = this.valueForSend;
              this.errorMessage = resp.message || "";
              // hide original modal then show confirmation to avoid two modals
              try {
                this.$modal.hide("addMilage");
              } catch (e) {}
              this.$modal.show("acceptUpdateMilage");
              // restore the value so user can confirm sending the same value
              this.valueForSend = pendingValue;
            } else {
              // generic 400 - show toast with server message
              this.$toast.error(
                resp.message || "Запрещено. Проверьте передаваемые данные",
                { duration: 5000 }
              );
            }
            EventBus.$emit("updateContentData");
          } else {
            const msg = (resp && resp.message) || "Ошибка сервера";
            this.$toast.error(msg, { duration: 5000 });
          }

          // mark input errors if provided
          if (resp && resp.errors) {
            Object.keys(resp.errors).forEach((elem) => {
              if (this.$refs[elem]) {
                this.$refs[elem].classList.add("input-error");
              }
            });
          }
        });
    },
  },
  mounted() {},
  beforeDestroy() {},

  computed: {
    ...mapState("modalStackModule", ["modalStackPosition"]),
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
